import moment from 'moment';
import { ModelBase } from '../abstract/model-base.model';

export class LegalDocument extends ModelBase {

    static override CLASS_NAME: string = 'LegalDocument';

    private _documentType!: string;
    private _versionCode!: string;
    private _versionDate!: moment.Moment;
    private _content!: string;

    public get documentType(): string {
        return this._documentType;
    }

    public set documentType(value: any) {
        this._setValue('_documentType', value, 'string');
    }

    public get versionCode(): string {
        return this._versionCode;
    }

    public set versionCode(value: any) {
        this._setValue('_versionCode', value, 'string');
    }

    public get versionDate(): moment.Moment {
        return this._versionDate;
    }

    public set versionDate(value: any) {
        this._setValue('_versionDate', value, 'date');
    }

    public get content(): string {
        return this._content;
    }

    public set content(value: any) {
        this._setValue('_content', value, 'string');
    }

    public isFuture(): boolean {
        return this.versionDate.isAfter(moment());
    }
}
